import React, { useContext, useEffect, useState } from "react";
import AppContext from "../../AppContext";

const WelcomeHeader = ({ weather }) => {
  const { authCtx } = useContext(AppContext);
  const [currentTime, setCurrentTime] = useState(new Date());

//   useEffect(() => {
//     const timer = setInterval(() => {
//       setCurrentTime(new Date());
//     }, 1000);

//     // In a real app, you would fetch actual weather data here
//     // This is just a simulation for the demo
//     const weatherIcons = {
//       Sunny: Sun,
//       Cloudy: Cloud,
//       "Partly Cloudy": CloudSun,
//       Rainy: CloudRain,
//       Snowy: Snowflake,
//     };

//     const mockWeatherConditions = ["Sunny", "Cloudy", "Partly Cloudy", "Rainy"];
//     const mockCondition =
//       mockWeatherConditions[
//         Math.floor(Math.random() * mockWeatherConditions.length)
//       ];
//     const mockTemp = Math.floor(Math.random() * 30) + 60; // Random temp between 60-90F

//     setWeather({
//       temp: mockTemp,
//       condition: mockCondition,
//       icon: weatherIcons[mockCondition],
//     });

//     return () => clearInterval(timer);
//   }, []);

  const formatDate = (date) => {
    return date.toLocaleDateString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const formatTime = (date) => {
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const greeting = () => {
    const hour = currentTime.getHours();
    if (hour < 12) return "Good morning";
    if (hour < 18) return "Good afternoon";
    return "Good evening";
  };

  const WeatherIcon = weather.icon;
  return (
    <div className="py-6 px-7 border border-gray-700 rounded-2xl bg-gradient-to-r from-gray-900 to-gray-800 backdrop-blur-sm shadow-xl overflow-hidden">
      <div className="flex md:flex-row items-center justify-between gap-4">
        {/* Greeting Section */}
        <div className="flex flex-col items-center md:items-start text-center md:text-left">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-100">
            {greeting()},{" "}
            <span className="text-orange-500">
              {authCtx?.profile?.name}
            </span>
          </h1>
          <p className="text-sm text-gray-300 mt-1">
            {formatDate(currentTime)}
          </p>
        </div>

        {/* Time & Weather Section */}
        <div className="flex items-center gap-6">
          {/* Time */}
          <div className="text-center">
            <p className="text-lg font-semibold text-white">
              {formatTime(currentTime)}
            </p>
          </div>

          {/* Weather */}
          <div className="flex items-center gap-2 bg-gray-800 px-3 py-2 rounded-lg border border-white/10 shadow-inner">
            <WeatherIcon className="h-6 w-6 text-orange-500" />
            <div className="leading-tight">
              <p className="text-base font-medium text-white">
                {weather.temp}°C
              </p>
              <p className="text-xs text-neutral-300">{weather.condition}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeHeader;
